import type { IconName } from '@/components/icons/icon'

export interface ConsoleNavItem {
  to: string
  label: string
  icon: IconName
  /** Only the exact path is active (Overview); otherwise child paths count too. */
  end?: boolean
  /** Shows the calls-needing-attention count (`.nav-count`). */
  attentionCount?: boolean
  /** Billing: the owner's alone (design docs §01). */
  ownerOnly?: boolean
}

/** The sidebar, in the prototype's order and words (console.html, `.nav`). */
export const NAV_PRIMARY: ConsoleNavItem[] = [
  { to: '/dashboard', label: 'Overview', icon: 'home', end: true },
  { to: '/dashboard/agents', label: 'Agents', icon: 'bot' },
  { to: '/dashboard/calls', label: 'Calls', icon: 'phone', attentionCount: true },
  { to: '/dashboard/bookings', label: 'Bookings', icon: 'cal' },
  { to: '/dashboard/numbers', label: 'Phone numbers', icon: 'hash' },
  { to: '/dashboard/analytics', label: 'Analytics', icon: 'chart' },
  { to: '/dashboard/ask-miya', label: 'Ask Miya', icon: 'spark' },
]

/** Under the "Configure" caption. */
export const NAV_CONFIGURE: ConsoleNavItem[] = [
  { to: '/dashboard/knowledge', label: 'Knowledge base', icon: 'book' },
  { to: '/dashboard/routing', label: 'Routing & handoffs', icon: 'route' },
  { to: '/dashboard/settings', label: 'Settings', icon: 'gear' },
  { to: '/dashboard/billing', label: 'Billing', icon: 'card', ownerOnly: true },
]

/** The mobile bottom bar: three daily destinations, then Menu (opens the drawer). */
export const NAV_MOBILE: ConsoleNavItem[] = [
  { to: '/dashboard', label: 'Overview', icon: 'home', end: true },
  { to: '/dashboard/calls', label: 'Calls', icon: 'phone' },
  { to: '/dashboard/bookings', label: 'Bookings', icon: 'cal' },
]
